import Wrapper from './checkbox.styled';

type CheckboxProps = {
  onFocus?: () => void;
  onBlur?: any;
  onChange?: any;
  checked?: boolean;
  name?: string;
  title?: string;
  mr?: string;
  isAlignRight?: boolean;
  disabled?: boolean;
};

const Checkbox = ({
  onFocus,
  onBlur,
  onChange,
  checked,
  name,
  title,
  mr,
  isAlignRight,
  disabled,
}: CheckboxProps) => {
  return (
    <Wrapper mr={mr}>
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        disabled={disabled}
      />
      <span className={`checkmark ${isAlignRight && 'tf-right'}`} />
      {title}
    </Wrapper>
  );
};

export default Checkbox;
